import {LightUser} from '../../interfaces/core/light-user';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {LightEmployee} from "../../interfaces/employees/light-employee";
import {User} from '../../interfaces/core/user';

export class LightUserFactory {

  /**
   *
   * @param lightUser
   */
  public static fromObject(lightUser: any): LightUser {
    return new class implements LightUser {
      // Deprecated: Uppercase
      employee: LightEmployee =
        LightEmployeeFactory.fromObject(lightUser.employee);
      id: number = lightUser.id;
    };
  }

  /**
   *
   * @param user
   */
  public static fromUser(user: User): LightUser {
    return new class implements LightUser {
      employee: LightEmployee = user.employee;
      id: number = user.id;
    };
  }

}
